import { useMemo, useState } from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { DEPLOYMENT_TEMPLATES_PAGE_SIZE } from "../../constants/pdm";
import { DeploymentTemplateDetailsDialog } from "./DeploymentTemplateDetailsDialog";
import { DeploymentTemplatesTable } from "./DeploymentTemplatesTable";
import { useDeploymentTemplatesList } from "./useDeploymentTemplatesList";

export default function TemplatesView() {
  const [page, setPage] = useState(0);
  const [selectedTemplateId, setSelectedTemplateId] = useState<string | null>(
    null,
  );

  const listQuery = useDeploymentTemplatesList(page);
  const rows = useMemo(() => listQuery.data?.items ?? [], [listQuery.data]);
  const total = listQuery.data?.total ?? 0;
  const detailsDialogOpen = selectedTemplateId !== null;

  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ color: "brand.main" }}>
        Deployment templates
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 2 }}>
        Browse deployment templates available in the DSApps Deployments manager.
      </Typography>

      <Alert severity="info" sx={{ mb: 2 }}>
        Contact the Blockchain Team if you cannot find the template you need.
      </Alert>

      {listQuery.isError ? (
        <Stack spacing={2} sx={{ mb: 2 }}>
          <Alert
            severity="error"
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => void listQuery.refetch()}
              >
                Retry
              </Button>
            }
          >
            Unable to load deployment templates.
          </Alert>
        </Stack>
      ) : null}

      <DeploymentTemplatesTable
        rows={rows}
        total={total}
        page={page}
        pageSize={DEPLOYMENT_TEMPLATES_PAGE_SIZE}
        isLoading={listQuery.isLoading}
        onPageChange={setPage}
        onViewDetails={(id) => setSelectedTemplateId(id)}
      />

      <DeploymentTemplateDetailsDialog
        open={detailsDialogOpen}
        templateId={selectedTemplateId}
        onClose={() => setSelectedTemplateId(null)}
      />
    </Box>
  );
}
